export function useFetchUser() {
  const authStore = useAuthStore();
  const fetchApi = useFetchApi();
  return useAsyncData(
    "user",
    () =>
      fetchApi
        .get("/v1/user")
        .then(({ body }) => body)
        .catch(() => null),
    {
      getCachedData(key, nuxtApp) {
        if (!authStore.isControlled) {
          return null;
        }
        return nuxtApp.payload.data[key] || nuxtApp.static.data[key];
      },
      server: false,
      lazy: true,
      deep: false,
      watch: [() => authStore.isControlled],
      dedupe: "defer",
      default: () => null,
    },
  );
}
